import { useEffect, useState } from 'react'
import * as Yup from "yup";
import { Button, Col, Form, Row } from 'reactstrap';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomPhoneNumberBox } from 'components/shared/CustomPhoneNumberBox';
import { CustomEmailBox } from 'components/shared/CustomEmailBox';
import { useFormik } from 'formik';
import { CustomToaster } from 'components/shared/CustomToaster';
import { IGetFeedBackDetail } from 'models/IGetFeedBackDetail';
import CommonService from 'services/CommonService';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import { isIn } from '../../helpers/Helper';
import { HelperConstant } from '../../helpers/HelperConstant';
import { CustomDropdown } from 'components/shared/CustomDropdown';

type Props = {
    setEditModel?: any,
    Id?: any,
    requestData(pageNumber: any, searchText: any, statusid: any, sortcolumn?: string, sortorder?: string): void,
    statusId: any,
    statusList: Array<any>
}

function CorporateTrendPopUp({ setEditModel, Id, requestData, statusList,statusId }: Props) {

    const [showToastUpdate, setShowToastUpdate] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: "",
            Mobile: "",
            Email: "",
            Subject: "",
            Description: "",
            FeedbackStatusId: 1,
            FeedbackStatusComments: '',
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("Please Enter Name").nullable(),
            Mobile: Yup.string().required("Please Enter Valid Mobile Number").matches(isIn() ? HelperConstant.phonenumberPattern.pattern : HelperConstant.UAEPhonenumberPattern.pattern, "Please Enter Valid Mobile Number").nullable(),
            Email: Yup.string().required("Please Enter Email").nullable(),
            Subject: Yup.string().required("Please Select the Subject").nullable(),
            Description: Yup.string().required("Please Select the Description").nullable(),
            FeedbackStatusId: Yup.string().notOneOf(['0'], 'Please select a Status').required("Please Select a Status").nullable(),
        }),

        onSubmit(values) {
            return onUpdateCorporateTrend(values as any);
        },
    })

    const onUpdateCorporateTrend = (data: IGetFeedBackDetail) => {
        setDisabled(true);
        CommonService.post('addressType', 'EditCorporateTrend', data).then((res: any) => {
            if (res.status == 200) {
                setEditModel(false);
                requestData(0, "", statusId, "desc", "modified");

            }
            setDisabled(false);
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const onGetCorporateTrend = () => {
        CommonService.getWithSingleParam('addressType', 'GetCorporateTrendById', Id).then((res: any) => {
            if (res.status == 200) {
                formik.setValues({ ...res.data });
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    useEffect(() => {
        onGetCorporateTrend();
    }, []);

    return (
        <div className="fl_content-style p-2">
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Row>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Name"
                            label="Name"
                            id={"Name"}
                            value={formik.values.Name}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Name && formik.errors.Name ? true : false}
                            error={formik.errors.Name}
                            onChange={formik.handleChange}
                            placeholder={"Name"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomEmailBox
                            name="Email"
                            label="Email"
                            id={"Email"}
                            value={formik.values.Email}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Email && formik.errors.Email ? true : false}
                            error={formik.errors.Email}
                            onChange={formik.handleChange}
                            placeholder={"Email"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomPhoneNumberBox
                            name="Mobile"
                            label="Phone Number"
                            id={"Mobile"}
                            value={formik.values.Mobile}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Mobile && formik.errors.Mobile ? true : false}
                            error={formik.errors.Mobile}
                            onChange={formik.handleChange}
                            placeholder={"+91 9087654321"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Subject"
                            label="Subject"
                            id={"Subject"}
                            value={formik.values.Subject}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Subject && formik.errors.Subject ? true : false}
                            error={formik.errors.Subject}
                            onChange={formik.handleChange}
                            placeholder={"Subject"}
                            isMandatory={false}
                        />
                    </Col>
                    
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <CustomTextArea name="Description"
                            label="Description"
                            id={"Description"}
                            value={formik.values.Description}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Description && formik.errors.Description ? true : false}
                            error={formik.errors.Description}
                            onChange={formik.handleChange}
                            placeholder={"Description"}
                            isMandatory={false}
                        />
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        <CustomDropdown
                            label={"Status"}
                            labelClassName={"mt-3"}
                            id={"FeedbackStatusId"}
                            name={"FeedbackStatusId"}
                            value={formik.values.FeedbackStatusId}
                            data={statusList}
                            displayField="Name"
                            valueField="Id"
                            touched={formik.touched.FeedbackStatusId}
                            error={formik.errors.FeedbackStatusId}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.FeedbackStatusId && formik.errors.FeedbackStatusId ? true : false}
                            isMandatory={false} />
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        <CustomTextArea
                            name="FeedbackStatusComments"
                            label="Notes"
                            id={"FeedbackStatusCommentsId"}
                            value={formik.values.FeedbackStatusComments}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.FeedbackStatusComments && formik.errors.FeedbackStatusComments ? true : false}
                            error={formik.errors.FeedbackStatusComments}
                            onChange={formik.handleChange}
                            isMandatory={false} /></Col>
                </Row>
                <Row>
                    <Col xl={6}></Col>
                    <Col xl={6} className='text-end'>
                        <Button className='btn btn-secondary m-2' type='button' onClick={() => { setEditModel(false); }}>Cancel</Button>
                        <Button className='btn btn-success' type='submit' disabled={disabled || statusId == HelperConstant.Corporate_Trade_In_StatusIds.Completed}>Update</Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <CustomToaster message={'Your delay response have been saved.'} color={'text-success'} toast={showToastUpdate} setToast={setShowToastUpdate} />
            </Row>
        </div>
    )
}

export default CorporateTrendPopUp